import { Component, OnInit } from '@angular/core';
import { ResourceService } from '@services/index.service';

/** Component que muestra un símbolo de carga */
@Component({
  selector: 'loading-component',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  constructor(public _resourceService: ResourceService) { }

  ngOnInit() {
  }

}
